export default __webpack_public_path__ + "static/media/WorkSans-Light.ac0dd029.woff2";